import styled from 'styled-components';

const PostCategory = styled.span.attrs({ className: 'post-category' })`
  display: block;
  margin-bottom: 12px;
  color: var(--slate);
  font-family: var(--font-mono);
  font-size: var(--fz-xs);
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export default PostCategory;
